import ContactPage from "@/layouts/ContactPage";
import ContentPage from "@/layouts/ContentPage";
import LandingPage from "@/layouts/LandingPage";

const PageRouter = ({ data }: { data: any }) => {
  switch (data.pageType) {
    case "ContentPage":
      return <ContentPage data={data} />;
    case "LandingPage":
      return <LandingPage data={data} />;
    case "ContactPage":
      return <ContactPage data={data} />;
    default:
      throw new Error(`Unknown page type: ${data.pageType}`);
  }
};

export default PageRouter;
